module.exports = __webpack_public_path__ + "img/discord-logo.fc0b01fe.png";